import C from '@/store/constants'

const VB_SERVICE_NAME = C.service.VB_SERVICE

export default {
  namespaced: true,

  actions: {

    status ({ dispatch }) {
      return new Promise(function(resolve, reject) {
        dispatch('API', VB_SERVICE_NAME, { root: true })
          .then(api => api.get('/bovra'))
          .then(response => resolve(response.data))
          .catch(err => reject(err))
      })
    },

    configure ({ dispatch }, data) {
      return new Promise(function(resolve, reject) {
        dispatch('API', VB_SERVICE_NAME, { root: true })
          .then(api => api.post('/bovra', data))
          .then(response => resolve(response.data))
          .catch(err => reject(err))
      })
    },

    createProject ({ dispatch }, project) {
      return new Promise(function(resolve, reject) {
        dispatch('API', VB_SERVICE_NAME, { root: true })
          .then(api => api.post('/bovra/projects', project))
          .then(response => resolve(response.data))
          .catch(err => reject(err))
      })
    },
  }
}
